import { Box } from '@mui/material'

export function BaseLayout(props: any) {
  return (
    <Box
      component={'div'}
      sx={{
        textAlign: 'center',
      }}
    >
      <Box
        component={'div'}
        sx={{
          display: 'inline-block',
          width: '100%',
          paddingTop: 'var(--sp-16, 64px)',
          backgroundColor: 'var(--color-canvas, #f0f0f0)',
          textAlign: 'center',
          alignItems: 'center',
          ...props.titleSx,
        }}
      >
        {props.pageTitle && (
          <Box
            component="div"
            sx={{
              fontFamily: (theme) =>
                (theme.typography as any).fontFamilyDisplay ||
                theme.typography.fontFamily,
              fontSize: 'var(--fs-18, 1.5rem)',
              fontWeight: 700,
              letterSpacing: 'var(--tracking-hero, 0.02em)',
              textTransform: 'uppercase',
              color: 'var(--color-text, #0d1418)',
              minHeight: 'var(--sp-16, 64px)',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 'var(--sp-2, 8px)',
            }}
          >
            {props.pageTitle && (
              <Box component={'p'} sx={{}}>
                {props.pageTitle}
              </Box>
            )}

            {props.pageTitle && props.pageSubtitle && (
              <Box component="p" sx={{ fontWeight: 'light' }}>
                -
              </Box>
            )}

            {props.pageSubtitle && (
              <Box component="p" sx={{ fontWeight: 'light' }}>
                {props.pageSubtitle}
              </Box>
            )}
          </Box>
        )}
        {props.wizardSteps && (
          <Box
            component={'div'}
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div>{props.wizardSteps}</div>
          </Box>
        )}
        {props.dashboardElement}
      </Box>

      {props.mainElement && (
        <Box
          component={'div'}
          sx={{
            display: 'inline-block',
            paddingBottom: 'var(--sp-24, 96px)',
            paddingTop: 'var(--sp-12, 96px)',
            alignItems: 'center',
            minWidth: '75%',
            maxWidth: '1500px',
            textAlign: 'left',
          }}
        >
          {props.mainElement}
        </Box>
      )}
      {props.wideElement && (
        <Box
          component={'div'}
          sx={{
            display: 'inline-block',
            paddingBottom: 'var(--sp-16, 64px)',
            paddingTop: 'var(--sp-12, 96px)',
            alignItems: 'center',
            width: '90%',
            minWidth: '1000px',
            maxWidth: '1900px',
            textAlign: 'left',
            minHeight: '400px',
          }}
        >
          {props.wideElement}
        </Box>
      )}
    </Box>
  )
}

export default BaseLayout
